import { LinkButton } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackOnlineBookingBookButton } from './tracking';
import { useIsDailyrentOnlineBooking } from '../../../../../../../shared/hooks/useIsDailyrentOnlineBooking';
import { selectJsonQuery } from '../../../../../../../shared/selectors/results';
import { useOfferContext } from '../../../../context';

export const OnlineBookingBookButtonContainer = () => {
  const jsonQuery = useSelector(selectJsonQuery);
  const isDailyrentOnlineBooking = useIsDailyrentOnlineBooking();
  const {
    trackingData: {
      page: { pageNumber, offersQty, queryString },
    },
    offer: { fullUrl, cianId },
    position,
  } = useOfferContext();

  const hasDates = !!jsonQuery.dates;
  const title = hasDates ? 'Забронировать' : 'Проверить даты';

  const onClick = React.useCallback(() => {
    trackOnlineBookingBookButton({
      cianId,
      position,
      offersQty,
      pageNumber,
      queryString,
      hasDates,
    });
  }, [cianId, hasDates, offersQty, pageNumber, position, queryString]);

  if (!isDailyrentOnlineBooking) {
    return null;
  }

  return (
    <LinkButton
      href={fullUrl}
      onClick={onClick}
      fullWidth
      size="XS"
      theme="fill_primary"
      target="_blank"
      rel="noopener noreferrer"
    >
      {title}
    </LinkButton>
  );
};
